import { render, staticRenderFns } from "./VoteLink.vue?vue&type=template&id=15e2d7f7&scoped=true&"
import script from "./VoteLink.vue?vue&type=script&lang=js&"
export * from "./VoteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e2d7f7",
  null
  
)

export default component.exports